import { Component, OnInit } from '@angular/core';
import { AppConfigService } from "../../appconfigservice";
import { ChapterInformation } from 'src/app/config';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.sass']
})
export class HomeComponent implements OnInit {

  comicNumber : number;
  currentChapterInformation : ChapterInformation;
  latestChapter : number;
  latestPage : number;

  constructor(private configService : AppConfigService) { }

  ngOnInit(): void {
    this.configService.chapters$.subscribe(data => 
    {
      this.latestChapter = this.configService.latestChapter$;
      this.latestPage = this.configService.latestPage$;
      this.currentChapterInformation = data?.get("1");
      this.comicNumber =  parseInt(this.currentChapterInformation?.numberOfPages);
    })
  }
}
